import { ScenarioTypeBase } from './base/scenario-type-base';

export class ScenarioType extends ScenarioTypeBase { }